import clsx from "clsx";
import { FC } from "react";
import styles from "./Card.module.css";

interface Props {
  src: string;
  title: string;
  type: "build" | "network" | "portfolio" | "funding";
}

const Card: FC<Props> = ({ src, title, type, children }) => {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <img src={src} alt={title} />
        <h4>{title}</h4>
        <p>{children}</p>
      </div>
      <div className={clsx(styles.bg, styles[type])}></div>
    </div>
  );
};

export default Card;
